var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9413 1.76524L3.97244 7.59161C2.13158 8.66751 1 10.6395 1 12.7718V24.3895C1 26.5217 2.13158 28.4938 3.97244 29.5697L13.9413 35.396C15.8078 36.4869 18.1169 36.4893 19.9856 35.4024L30.0167 29.5677C31.8637 28.4934 33 26.5179 33 24.3812V12.7801C33 10.6434 31.8637 8.66794 30.0167 7.59363L19.9856 1.75894C18.1169 0.671947 15.8078 0.674358 13.9413 1.76524Z",
    fill: "white",
    stroke: "#ECE9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1959 3.92123L6.08922 8.69402C4.2577 9.77232 3.1333 11.7391 3.1333 13.8645V23.4689C3.1333 25.5942 4.2577 27.561 6.08922 28.6393L14.196 33.4121C16.0708 34.5159 18.3962 34.5183 20.2733 33.4185L28.4332 28.6373C30.2709 27.5606 31.4 25.5904 31.4 23.4605V13.8728C31.4 11.743 30.2709 9.77272 28.4332 8.69599L20.2733 3.91486C18.3962 2.81501 16.0707 2.81745 14.1959 3.92123Z",
    fill: "#46B0C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2826 6.1728L8.3041 9.7166C6.48126 10.7971 5.36353 12.759 5.36353 14.878V22.116C5.36353 24.235 6.48126 26.1969 8.3041 27.2774L14.2826 30.8212C16.1651 31.937 18.5058 31.9395 20.3907 30.8276L26.4121 27.2754C28.2411 26.1965 29.3635 24.2311 29.3635 22.1076V14.8863C29.3635 12.7628 28.2411 10.7975 26.4121 9.71854L20.3906 6.16638C18.5058 5.05449 16.1651 5.05694 14.2826 6.1728Z",
    fill: "#73D9EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_483_115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2826 6.1728L8.3041 9.7166C6.48126 10.7971 5.36353 12.759 5.36353 14.878V22.116C5.36353 24.235 6.48126 26.1969 8.3041 27.2774L14.2826 30.8212C16.1651 31.937 18.5058 31.9395 20.3907 30.8276L26.4121 27.2754C28.2411 26.1965 29.3635 24.2311 29.3635 22.1076V14.8863C29.3635 12.7628 28.2411 10.7975 26.4121 9.71854L20.3906 6.16638C18.5058 5.05449 16.1651 5.05694 14.2826 6.1728Z",
    fill: "#FFC100"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_483_115)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.36353,
    y: 5.09091,
    width: 11.6364,
    height: 26.9091,
    fill: "#5DC9DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.cbdd436cac12c5b71ed1a2bdacdc266b.svg";
export { ForwardRef as ReactComponent };